import React from "react";

const NewsCard = (props) => {
  return (
    <section className="i-news-item">
      <img className="news-img" src={props.image} />
      <p className="i-news-text">{props.info}</p>
      <div className="read-more">
        <a href={props.link}>Read more...</a>
      </div>
      <div className="news-like">
        <i class="fa-solid fa-heart "></i>
      </div>
    </section>
  );
};

export default NewsCard;
